// extracted by mini-css-extract-plugin
export default {"messagesWrapper":"FormWarningMessage_messagesWrapper__RlI5q","messageItem":"FormWarningMessage_messageItem__mUItS","messageHidden":"FormWarningMessage_messageHidden__x7KFs"};